import { JSX } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { RoleType } from '@addmile/backend-client';

import { ROUTES } from '../../routes';
import { useHubStore } from '../../store/hubStore';
import { isAuthenticated } from '../../utils/auth';

const MiddlewareRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const user = useHubStore((state) => state.user);
  const isCoach = user?.role === RoleType.Coach;

  const allowedCoachRoutes = [
    ROUTES.SIGN_IN,
    ROUTES.COACH,
    ROUTES.COACH_SCHEDULE,
    ROUTES.COACH_CALENDAR,
    ROUTES.ADMIN_SESSION,
    '/coach/calendar/register', // Base path for register route
  ];

  const isAllowedCoachRoute =
    allowedCoachRoutes.some((route) => location.pathname.startsWith(route)) ||
    /^\/admin\/sessions\/[0-9a-fA-F-]+$/.test(location.pathname);

  if (!isAuthenticated()) {
    return <Navigate to={ROUTES.SIGN_IN} />;
  }

  if ((isCoach && !isAllowedCoachRoute) || (isCoach && location.pathname === ROUTES.HOME)) {
    return <Navigate to={ROUTES.COACH} />;
  }

  return children;
};

export default MiddlewareRoute;
